import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button, Input,Checkbox } from '../../../node_modules/semantic-ui-react';
import SelectEmployees from '../../Commons/SelectEmployees';
import FilterGroupSection, { emptyFilterGroup } from '../../Commons/FilterGroupSection';
const moment = require('moment');

class LateReportModel extends Component {

    constructor(props) {
        super(props);
        var defaultState = {
            filterGroup: emptyFilterGroup(),
            fromDate: moment().startOf('day').format("YYYY-MM-DD"),
            toDate: moment().startOf('day').format("YYYY-MM-DD"),
            EmployeeIds:[],
            includeEmptyEntries:true,
            includeAmount : false,
            searchQuery:'',
            Employeelist:[]
        };

        const savedState = sessionStorage.getItem("LateReportFilterState");
        if (savedState) {
            try {
                this.state = { ...defaultState, ...JSON.parse(savedState) };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            EmployeeIds: this.state.EmployeeIds,
            includeEmptyEntries: this.state.includeEmptyEntries,
            includeAmount: this.state.includeAmount
        };
        sessionStorage.setItem("LateReportFilterState", JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            message: "from tardiness modal",
            EmployeeIds:this.state.EmployeeIds,
            includeEmptyEntries: this.state.includeEmptyEntries,
            includeAmount : this.state.includeAmount
        };
    }

    updateEmployeeIds = (ids) =>{
        this.setState({ EmployeeIds: ids});
    }
    handleCheckChange = (e) =>{
        e.target.textContent === "Include Amount" ?
        this.setState(prevState => ({ includeAmount: !prevState.includeAmount})) :
        this.setState(prevState => ({ includeEmptyEntries : !prevState.includeEmptyEntries }));
    }
    render() {
        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Report Filters</p>
                </Modal.Header>
                <Modal.Content>
                    <div class="ui grid">
                        <div class="left floated left aligned eight wide column">
                            <Input type="date" label="From Date" size="mini" fluid value={this.state.fromDate} onChange={(event, data)=>{this.setState({fromDate:data.value})}} />
                        </div>
                        <div class="right floated right aligned eight wide column">
                            <Input type="date" label="To Date" size="mini" fluid value={this.state.toDate} onChange={(event, data)=>{this.setState({toDate:data.value})}} />   
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                        <label>Employee</label>
                            <SelectEmployees filterGroup={this.state.filterGroup} Ids={this.state.EmployeeIds} update={this.updateEmployeeIds.bind(this)}/>
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                        <Checkbox toggle fluid label="Include empty entries" 
                                    checked={this.state.includeEmptyEntries}
                                    onClick={this.handleCheckChange.bind(this)}/>
                        </div>
                        <div class="right floated right aligned sixteen wide">
                        <Checkbox toggle fluid label="Include Amount" 
                                    checked={this.state.includeAmount}
                                    onClick={this.handleCheckChange.bind(this)}/>
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button positive content="Generate" onClick={this.props.onSave}></Button>
                    <Button negative content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }

}

export default LateReportModel;